<template>
  <div
    :id="id"
    class="upsells-item align-items-center"
    :class="{
      main: !withRemoveButton,
      'is-accessory': withRemoveButton
    }"
  >
    <div class="upsells-item__image col-4">
      <img :src="imageUrl" alt="" />
    </div>
    <div class="upsells-item__content pl-2">
      <h5>{{ name }}</h5>
      <ul class="benefit-list">
        <!-- <li v-for="benefit in benefitList" :key="benefit">
          BEN:{{ benefit }}
        </li> -->
        <li>
          {{ itemData ? (itemData.productName || itemData.name) : '' }}
        </li>
        <li v-if="!itemData || (itemData && itemData.id !== 'warranty')">
          {{ textQuantity }}: {{ quantity }}
        </li>
        <li>
          {{ textSubtotal }}:
          {{ idx === 0 && upsellDiscount ? priceD : finalPrice || subtotal }}
        </li>
        <li v-if="warranty">
          {{ textWarranty }}:
          {{ warranty }}
        </li>
        <li v-if="itemData && itemData.id !== 'warranty'">
          ({{ rating }})
          <div class="review-5star d-inline-block" :style="{ width: 5 * 20 + 'px' }">
            <img :src="$root.cdn_url + '/assets/images/zmc10/5star.svg'" />
          </div>
        </li>
      </ul>
    </div>
    <div class="upsells-item__remove-block" v-if="withRemoveButton">
      <div class="btn btn-danger btn-sm" @click="deleteAccessory">
        {{ textRemove }}
      </div>
    </div>
  </div>
</template>

<script>
import { t } from "../../utils/i18n";
import { fade } from "../../utils/common";
import upsellsMixin from "../../mixins/upsells";

export default {
  name: "UpsellsItem",
  mixins: [upsellsMixin],
  props: [
    "name",
    "benefitList",
    "upsellDiscount",
    "priceD",
    "withRemoveButton",
    "imageUrl",
    "idx",
    "itemData",
    "price",
    "quantity",
    "subtotal",
    "finalPrice",
    "warranty"
  ],

  data: () => ({
    upsellPrices: null
  }),

  computed: {
    id() {
      return "upsells-item-" + this.idx;
    },

    textSubtotal() {
      return t("upsells.subtotal");
    },

    textWarranty() {
      return t("upsells.warranty");
    },

    textRemove() {
      return t("upsells.remove");
    },
    
    textQuantity: () => t("upsells.quantity"),

    rating() {
      return Math.floor(Math.random() * 900) + 100;
    },
  },

  methods: {
    deleteAccessory() {
      let subOrder = [];

      try {
        subOrder = JSON.parse(localStorage.getItem("subOrder")) || [];
        const deleteIndex = subOrder.findIndex(item => item.id == this.itemData.id);
        subOrder.splice(deleteIndex, 1);
      } catch (err) {}

      localStorage.setItem("subOrder", JSON.stringify(subOrder));
      this.$emit("deleteAccessory", this.idx);
    }
  }
};
</script>

<style lang="scss">
.upsells-component {
  .upsells-item {
    display: flex;

    &__image {
      max-width: 170px;
      padding: 7px;

      img {
        width: 100%;
        height: auto;
      }
    }

    &__content {
      flex-grow: 1;

      .benefit-list {
        list-style-type: none;
        padding: 0;
        font-size: 16px;
        line-height: 19px;
        color: #7d8180;

        li {
          margin-bottom: 5px;
        }
      }
    }

    &__remove-block {
      display: flex;
      align-items: flex-end;

      & > button {
        padding: 8px;
      }
    }

    &.main {
      h5 {
        font-size: 18px;
        line-height: 21px;
        color: #333333;
      }
    }

    &.is-accessory {
      .upsells-item__content {
        h5 {
          margin-top: 8px;
        }

        .benefit-list {
          li {
            &:first-child {
              font-size: 18px;
              line-height: 21px;
              color: #333333;
            }
          }
        }
      }
    }
  }
}
</style>
